

import React, { useState, useEffect, useRef } from "react";
import Sidebar from "../../Components/Sidebar";
import TopNav from "../../Components/TopNav";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import JoditEditor from "jodit-react";
import {
  updateBlogServ,
  getBlogDetailsServ,
} from "../../services/blog.service";
import { useNavigate, useParams } from "react-router-dom";
import { IMAGE_BASE_URL } from "../../utils/api_base_url_configration";



/* ─── Scoped styles — same design language as AddBlog / BlogList / OrderList ─── */
const styles = `
  @import url('https://fonts.googleapis.com/css2?family=DM+Sans:wght@400;500;600;700&family=DM+Mono:wght@500&display=swap');

  .ub-page {
    background: #f5f5f7;
    min-height: 100%;
    padding: 28px;
    font-family: 'DM Sans', 'Segoe UI', sans-serif;
    font-size: 15px;
  }

  /* ── Page header ── */
  .ub-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 22px;
    flex-wrap: wrap;
    gap: 12px;
  }
  .ub-header-left {
    display: flex;
    align-items: center;
    gap: 12px;
  }
  .ub-back-btn {
    width: 40px;
    height: 40px;
    border-radius: 11px;
    border: 1px solid #f0eded;
    background: #fff;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 18px;
    color: #555;
    cursor: pointer;
    transition: all 0.18s;
    flex-shrink: 0;
  }
  .ub-back-btn:hover { background: #fdf2f1; color: #a60808; border-color: #f0c0b8; }

  .ub-page-title {
    font-size: 22px;
    font-weight: 700;
    color: #1c0a0a;
    letter-spacing: -0.4px;
  }
  .ub-breadcrumb {
    font-size: 13px;
    color: #aaa;
    margin-top: 3px;
    font-weight: 500;
  }
  .ub-breadcrumb span { color: #a60808; }

  /* ── Update badge on header ── */
  .ub-update-badge {
    display: inline-flex;
    align-items: center;
    gap: 7px;
    background: #fdf2f1;
    border: 1px solid #f0c0b8;
    border-radius: 10px;
    padding: 7px 16px;
    font-size: 13px;
    font-weight: 600;
    color: #a60808;
  }

  /* ── Card ── */
  .ub-card {
    background: #fff;
    border-radius: 16px;
    border: 1px solid #f0eded;
    padding: 28px 28px 32px;
    margin-bottom: 18px;
  }
  .ub-section-title {
    font-size: 14px;
    font-weight: 700;
    color: #a60808;
    text-transform: uppercase;
    letter-spacing: 0.9px;
    margin-bottom: 20px;
    display: flex;
    align-items: center;
    gap: 8px;
  }
  .ub-section-title::after {
    content: '';
    flex: 1;
    height: 1px;
    background: #f0eded;
  }

  /* ── Form grid ── */
  .ub-grid   { display: grid; gap: 20px; }
  .ub-grid-2 { grid-template-columns: 1fr 1fr; }
  .ub-grid-3 { grid-template-columns: 1fr 1fr 1fr; }
  @media (max-width: 768px) {
    .ub-grid-2, .ub-grid-3 { grid-template-columns: 1fr; }
  }

  /* ── Field ── */
  .ub-field { display: flex; flex-direction: column; gap: 7px; }
  .ub-label {
    font-size: 13.5px;
    font-weight: 600;
    color: #333;
    letter-spacing: 0.1px;
  }
  .ub-label .ub-req  { color: #a60808; margin-left: 2px; }
  .ub-label .ub-hint { font-size: 12px; color: #aaa; font-weight: 400; margin-left: 5px; }

  .ub-input,
  .ub-select,
  .ub-textarea {
    height: 46px;
    border-radius: 11px;
    border: 1px solid #ede9e9;
    padding: 0 16px;
    font-size: 15px;
    color: #333;
    background: #fafafa;
    outline: none;
    font-family: 'DM Sans', sans-serif;
    transition: border-color 0.15s, background 0.15s, box-shadow 0.15s;
    width: 100%;
  }
  .ub-input:focus,
  .ub-select:focus,
  .ub-textarea:focus {
    border-color: #f0c0b8;
    background: #fff;
    box-shadow: 0 0 0 3px rgba(192,57,43,0.07);
  }
  .ub-input::placeholder,
  .ub-textarea::placeholder { color: #ccc; }

  .ub-textarea {
    height: auto;
    padding: 14px 16px;
    resize: vertical;
    line-height: 1.6;
  }
  .ub-select {
    appearance: none;
    background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' viewBox='0 0 24 24' fill='none' stroke='%23aaa' stroke-width='2.5'%3E%3Cpath d='M6 9l6 6 6-6'/%3E%3C/svg%3E");
    background-repeat: no-repeat;
    background-position: right 14px center;
    background-color: #fafafa;
    padding-right: 38px;
    cursor: pointer;
  }

  /* ── Status select highlight ── */
  .ub-select.status-active  { border-color: #a8e6b0; background: #f2fdf4; color: #1e8449; }
  .ub-select.status-inactive { border-color: #f5d49a; background: #fefdf2; color: #b7770d; }

  /* ── Banner upload ── */
  .ub-banner-wrap {
    border-radius: 12px;
    border: 2px dashed #ede9e9;
    overflow: hidden;
    background: #fafafa;
    transition: border-color 0.18s;
    cursor: pointer;
  }
  .ub-banner-wrap:hover { border-color: #f0c0b8; }
  .ub-banner-preview {
    width: 100%;
    height: 200px;
    object-fit: cover;
    display: block;
  }
  .ub-banner-placeholder {
    height: 200px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 10px;
    color: #ccc;
  }
  .ub-banner-placeholder i { font-size: 38px; color: #e8d0cd; }
  .ub-banner-placeholder p { font-size: 14px; color: #bbb; font-weight: 500; margin: 0; }
  .ub-file-input {
    margin-top: 10px;
    width: 100%;
    font-size: 14px;
    font-family: 'DM Sans', sans-serif;
    color: #555;
  }
  .ub-file-input::file-selector-button {
    height: 36px;
    border-radius: 9px;
    border: 1px solid #f0eded;
    background: #fff;
    padding: 0 16px;
    font-size: 13.5px;
    font-weight: 600;
    color: #a60808;
    cursor: pointer;
    margin-right: 12px;
    font-family: 'DM Sans', sans-serif;
    transition: background 0.15s;
  }
  .ub-file-input::file-selector-button:hover { background: #fdf2f1; }

  /* ── Jodit editor override ── */
  .jodit-container {
    border-radius: 11px !important;
    border: 1px solid #ede9e9 !important;
    font-size: 15px !important;
    overflow: hidden;
    font-family: 'DM Sans', sans-serif !important;
    transition: border-color 0.15s, box-shadow 0.15s;
  }
  .jodit-container:focus-within {
    border-color: #f0c0b8 !important;
    box-shadow: 0 0 0 3px rgba(192,57,43,0.07) !important;
  }
  .jodit-toolbar__box {
    border-bottom: 1px solid #f0eded !important;
    background: #fafafa !important;
  }
  .jodit-wysiwyg {
    font-family: 'DM Sans', sans-serif !important;
    font-size: 15px !important;
    color: #333 !important;
    min-height: 160px !important;
  }

  /* ── Skeleton loader for prefill ── */
  .ub-skeleton {
    background: linear-gradient(90deg, #f0eded 25%, #e8e4e4 50%, #f0eded 75%);
    background-size: 200% 100%;
    animation: ub-shimmer 1.4s infinite;
    border-radius: 8px;
    height: 46px;
    width: 100%;
  }
  @keyframes ub-shimmer {
    0%   { background-position: 200% 0; }
    100% { background-position: -200% 0; }
  }

  /* ── Actions ── */
  .ub-actions {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    gap: 12px;
    margin-top: 4px;
  }
  .ub-required-note {
    font-size: 13px;
    color: #bbb;
    font-style: italic;
    margin-right: auto;
  }
  .ub-required-note span { color: #a60808; }

  .ub-cancel-btn {
    height: 48px;
    padding: 0 28px;
    border-radius: 12px;
    border: 1px solid #ede9e9;
    background: #fff;
    font-size: 15px;
    font-weight: 600;
    color: #666;
    cursor: pointer;
    font-family: 'DM Sans', sans-serif;
    transition: all 0.18s;
  }
  .ub-cancel-btn:hover { background: #f5f5f7; color: #333; }

  .ub-submit-btn {
    height: 48px;
    padding: 0 36px;
    border-radius: 12px;
    border: none;
    background: #a60808;
    color: #fff;
    font-size: 15px;
    font-weight: 700;
    cursor: pointer;
    font-family: 'DM Sans', sans-serif;
    letter-spacing: 0.2px;
    display: inline-flex;
    align-items: center;
    gap: 8px;
    transition: background 0.18s, transform 0.1s, opacity 0.18s;
  }
  .ub-submit-btn:hover:not(:disabled) { background: #a93226; transform: translateY(-1px); }
  .ub-submit-btn:active:not(:disabled) { transform: translateY(0); }
  .ub-submit-btn:disabled { opacity: 0.5; cursor: not-allowed; }

  @keyframes spin { from { transform: rotate(0deg); } to { transform: rotate(360deg); } }
`;

function UpdateBlog() {

   const getImageUrl = (image) => {
  if (!image) return "";

  // Blob preview
  if (image.startsWith("blob:")) return image;

  // Cloudinary / Full URL
  if (image.startsWith("http")) return image;

  // Local upload
  return `${IMAGE_BASE_URL}${image}`;
};

  const navigate = useNavigate();
  const params = useParams();
  const editor = useRef(null);
  const [pageLoading, setPageLoading] = useState(true);

  const config = {
    placeholder: "Start typing...",
    height: "280px",
    toolbarButtonSize: "middle",
  };

  const [loader, setLoader] = useState(false);
  const [formData, setFormData] = useState({
    image: "",
    imgPrev: "",
    title: "",
    seoTitle: "",
    metaKeyword: "",
    metaDescription: "",
    rank: "",
    tags: "",
    status: "",
    specialAppereance: "",
  });
  const [shortDescription, setShortDescription] = useState("");
  const [description, setDescription] = useState("");

  const getBlogDetailsFunc = async () => {
    setPageLoading(true);
    try {
      let response = await getBlogDetailsServ(params?.id);
      if (response?.data?.statusCode == "200") {
        const d = response.data.data;
        setFormData({
          imgPrev: d?.image || "",
          image: "",
          title: d?.title || "",
          seoTitle: d?.seoTitle || "",
          metaKeyword: d?.metaKeyword || "",
          metaDescription: d?.metaDescription || "",
          rank: d?.rank || "",
          tags: d?.tags || "",
          status: d?.status ?? "",
          specialAppereance: d?.specialAppereance || "",
        });
        setShortDescription(d?.shortDescription || "");
        setDescription(d?.description || "");
      }
    } catch (error) {
      toast.error("Failed to load blog details");
    }
    setPageLoading(false);
  };

  useEffect(() => {
    getBlogDetailsFunc();
  }, [params?.id]);

  const handleSubmit = async () => {
    setLoader(true);
    try {
      let finalPayload = {
        ...formData,
        shortDescription,
        description,
        id: params?.id,
      };
      let response = await updateBlogServ(finalPayload);
      if (response?.data?.statusCode == "200") {
        toast.success("Blog updated successfully!");
        navigate("/blogs-list");
      }
    } catch (error) {
      toast.error("Internal Server Error");
    }
    setLoader(false);
  };

  const isFormValid =
    formData.title &&
    formData.rank &&
    formData.tags.length > 0 &&
    shortDescription;

  const statusClass =
    String(formData.status) === "true"
      ? "status-active"
      : String(formData.status) === "false"
      ? "status-inactive"
      : "";

  return (
    <div className="bodyContainer">
      <style>{styles}</style>
      <Sidebar selectedMenu="Blog Management" selectedItem="Add Blog" />

      <div className="mainContainer">
        <TopNav />

        <div className="ub-page">

          {/* ── Page Header ── */}
          <div className="ub-header">
            <div className="ub-header-left">
              <button className="ub-back-btn" onClick={() => navigate("/blogs-list")}>
                <i className="ti ti-arrow-left" aria-hidden="true" />
              </button>
              <div>
                <div className="ub-page-title">Update Blog</div>
                <div className="ub-breadcrumb">
                  Blog Management &rsaquo; <span>Edit Blog</span>
                </div>
              </div>
            </div>
            <div className="ub-update-badge">
              <i className="ti ti-edit" aria-hidden="true" />
              Editing ID: {params?.id?.slice(-6)?.toUpperCase()}
            </div>
          </div>

          {/* ── Section 1: Banner ── */}
          <div className="ub-card">
            <div className="ub-section-title">
              <i className="ti ti-photo" aria-hidden="true" /> Banner Image
            </div>
            <div className="ub-field">
              <label className="ub-label">
                Blog Banner <span className="ub-req">*</span>
              </label>
              <div className="ub-banner-wrap">
                {formData.imgPrev ? (
                  <img
                   src={getImageUrl(formData.imgPrev)}
                    alt="Banner preview"
                    className="ub-banner-preview"
                  />
                ) : (
                  <div className="ub-banner-placeholder">
                    <i className="ti ti-cloud-upload" aria-hidden="true" />
                    <p>No image selected</p>
                  </div>
                )}
              </div>
              <input
                className="ub-file-input"
                type="file"
                accept="image/*"
                onChange={(e) =>
                  setFormData({
                    ...formData,
                    image: e.target.files[0],
                    imgPrev: URL.createObjectURL(e.target.files[0]),
                  })
                }
              />
            </div>
          </div>

          {/* ── Section 2: Basic Info ── */}
          <div className="ub-card">
            <div className="ub-section-title">
              <i className="ti ti-article" aria-hidden="true" /> Basic Information
            </div>

            <div className="ub-grid ub-grid-2" style={{ marginBottom: "20px" }}>
              <div className="ub-field">
                <label className="ub-label">
                  Title <span className="ub-req">*</span>
                </label>
                {pageLoading ? <div className="ub-skeleton" /> : (
                  <input
                    className="ub-input"
                    placeholder="Enter blog title"
                    value={formData.title}
                    onChange={(e) => setFormData({ ...formData, title: e.target.value })}
                  />
                )}
              </div>
              <div className="ub-field">
                <label className="ub-label">SEO Title</label>
                {pageLoading ? <div className="ub-skeleton" /> : (
                  <input
                    className="ub-input"
                    placeholder="Enter SEO title"
                    value={formData.seoTitle}
                    onChange={(e) => setFormData({ ...formData, seoTitle: e.target.value })}
                  />
                )}
              </div>
            </div>

            <div className="ub-grid ub-grid-3" style={{ marginBottom: "20px" }}>
              <div className="ub-field">
                <label className="ub-label">
                  Tags <span className="ub-req">*</span>
                  <span className="ub-hint">(comma separated)</span>
                </label>
                {pageLoading ? <div className="ub-skeleton" /> : (
                  <input
                    className="ub-input"
                    placeholder="e.g. health, tips"
                    value={formData.tags}
                    onChange={(e) => setFormData({ ...formData, tags: e.target.value })}
                  />
                )}
              </div>
              <div className="ub-field">
                <label className="ub-label">
                  Rank <span className="ub-req">*</span>
                </label>
                {pageLoading ? <div className="ub-skeleton" /> : (
                  <input
                    className="ub-input"
                    type="number"
                    placeholder="e.g. 1"
                    value={formData.rank}
                    onChange={(e) => setFormData({ ...formData, rank: e.target.value })}
                  />
                )}
              </div>
              <div className="ub-field">
                <label className="ub-label">Special Appearance</label>
                {pageLoading ? <div className="ub-skeleton" /> : (
                  <select
                    className="ub-select"
                    value={formData.specialAppereance}
                    onChange={(e) => setFormData({ ...formData, specialAppereance: e.target.value })}
                  >
                    <option value="">Select</option>
                    <option value="Home">Home</option>
                  </select>
                )}
              </div>
            </div>

            <div className="ub-grid ub-grid-2">
              <div className="ub-field">
                <label className="ub-label">
                  Meta Keywords
                  <span className="ub-hint">(comma separated)</span>
                </label>
                {pageLoading ? <div className="ub-skeleton" /> : (
                  <input
                    className="ub-input"
                    placeholder="e.g. blog, seo, keywords"
                    value={formData.metaKeyword}
                    onChange={(e) => setFormData({ ...formData, metaKeyword: e.target.value })}
                  />
                )}
              </div>
              <div className="ub-field">
                <label className="ub-label">
                  Status <span className="ub-req">*</span>
                </label>
                {pageLoading ? <div className="ub-skeleton" /> : (
                  <select
                    className={`ub-select ${statusClass}`}
                    value={formData.status}
                    onChange={(e) => setFormData({ ...formData, status: e.target.value })}
                  >
                    <option value="">Select Status</option>
                    <option value={true}>Active</option>
                    <option value={false}>Inactive</option>
                  </select>
                )}
              </div>
            </div>
          </div>

          {/* ── Section 3: SEO & Content ── */}
          <div className="ub-card">
            <div className="ub-section-title">
              <i className="ti ti-search" aria-hidden="true" /> SEO & Content
            </div>

            <div className="ub-field" style={{ marginBottom: "20px" }}>
              <label className="ub-label">Meta Description</label>
              {pageLoading ? (
                <div className="ub-skeleton" style={{ height: "90px" }} />
              ) : (
                <textarea
                  className="ub-textarea"
                  rows={3}
                  placeholder="Write a brief meta description for SEO..."
                  value={formData.metaDescription}
                  onChange={(e) => setFormData({ ...formData, metaDescription: e.target.value })}
                />
              )}
            </div>

            <div className="ub-field" style={{ marginBottom: "20px" }}>
              <label className="ub-label">
                Short Description <span className="ub-req">*</span>
              </label>
              {!pageLoading && (
                <JoditEditor
                  ref={editor}
                  config={config}
                  value={shortDescription}
                  onChange={(newContent) => setShortDescription(newContent)}
                />
              )}
              {pageLoading && <div className="ub-skeleton" style={{ height: "160px" }} />}
            </div>

            <div className="ub-field">
              <label className="ub-label">Full Description</label>
              {!pageLoading && (
                <JoditEditor
                  config={config}
                  value={description}
                  onChange={(newContent) => setDescription(newContent)}
                />
              )}
              {pageLoading && <div className="ub-skeleton" style={{ height: "160px" }} />}
            </div>
          </div>

          {/* ── Actions ── */}
          <div className="ub-card" style={{ padding: "20px 28px" }}>
            <div className="ub-actions">
              <span className="ub-required-note">
                <span>*</span> Required fields
              </span>
              <button
                className="ub-cancel-btn"
                onClick={() => navigate("/blogs-list")}
              >
                Cancel
              </button>
              <button
                className="ub-submit-btn"
                onClick={isFormValid && !loader ? handleSubmit : undefined}
                disabled={!isFormValid || loader}
              >
                {loader ? (
                  <>
                    <i
                      className="ti ti-loader-2"
                      style={{ animation: "spin 1s linear infinite" }}
                      aria-hidden="true"
                    />
                    Saving...
                  </>
                ) : (
                  <>
                    <i className="ti ti-device-floppy" aria-hidden="true" />
                    Update Blog
                  </>
                )}
              </button>
            </div>
          </div>

        </div>
      </div>
    </div>
  );
}

export default UpdateBlog;